<template>
  <PTCLink
    to="#"
    :class="{
      'arrow relative cursor-pointer border-2 px-5 py-2 font-ptc-Rajdhani text-lg font-bold uppercase leading-18px focus-visible:border-2 focus-visible:border-www-color-primary-lighter': true,
      'after:border-transparent after:ml-2 after:inline-block after:border-b-0 after:border-solid after:align-[0.255em]': true,
      'border-www-color-transparent': !isDropdownVisible,
      'rounded border-www-color-primary-lighter after:rotate-180': isDropdownVisible,
      [buttonClass]: true,
    }"
    @click.prevent="toggleDropdown"
  >
    {{ parentButtonText }}
  </PTCLink>
  <ul
    v-show="isDropdownVisible"
    :class="{
      'absolute top-9 w-full list-none rounded border border-custom-black py-2 text-left text-base shadow-custom': true,
      [backgroundClass]: true,
    }"
  >
    <li
      v-for="(Link, index) in subNavigation"
      :key="index"
      :class="{
        'mb-2 text-base leading-7 last:mb-0': true,
      }"
    >
      <MicroSiteNavButton
        v-if="Link._type === 'microSiteNavButton'"
        v-bind="Link"
        :button-style="background?.background"
        :class="{
          'py-1 font-normal capitalize': true,
        }"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import MicroSiteNavButton from '~/features/MicroSite/MicroSiteNavButton.vue';
import PTCLink from '~/components/Atoms/PTCLink/PTCLink.vue';
import type { MicroSiteDropdownMenu } from '~/sanity/types';
import { backgroundColorClasses } from '~/components/Atoms/Background/BgColorMap';
interface Props extends MicroSiteDropdownMenu {
  buttonStyle?: string;
}
const props = defineProps<Props>();
const { buttonStyle } = toRefs(props);
const buttonClass = computed(() => {
  return buttonClasses[buttonStyle.value ?? 'transparent'] ?? buttonClasses['transparent'] ?? '';
});
const backgroundClass = computed(() => {
  return backgroundColorClasses[props?.background?.background ?? 'transparent'] ?? '';
});
const buttonClasses: Record<string, string> = {
  transparent:
    'transparent border-www-color-primary-lighter bg-www-color-transparent text-www-color-white hover:border-www-color-primary-light focus:border-2 active:border-www-color-primary-light',
  'secondary-alt':
    'secondary border-www-color-neutral-medium bg-www-color-white text-www-color-neutral-medium hover:text-www-color-neutral-medium focus:border-2 active:text-www-color-neutral-medium active:border-www-color-primary-light',
};
const isDropdownVisible = ref(false);

function toggleDropdown() {
  isDropdownVisible.value = !isDropdownVisible.value;
}
</script>

<style>
.arrow::after {
  content: '';
  border-left: 0.3em solid transparent;
  border-right: 0.3em solid transparent;
  border-top: 0.3em solid;
  transition: all 0.3s ease-in-out;
}
</style>
